import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";

export interface JobNotesPropsHook {
  notes?: string;
}

export default function useJobNotesProps(): JobNotesPropsHook {
  const job = useSelector(jobSelectors.getEntity);

  const [notes] = job?.notes || [];

  return {
    notes,
  };
}
